import { IUseClawMachineCoins, AdminClawMachineCoinsEndpoints, fetcher, AdminUserEndpoints } from "@olagg/api-hooks";
import { AdminClawMachineCoin } from "@olagg/db-types";
import { useState } from "react";

interface CoinsResponse {
  clawMachineCoins: AdminClawMachineCoin[]
  meta: {
    count: number
  }
}

const useClawMachineCoins = () => {
  const [loading, setLoading] = useState(false)

  const getClawCoins = async (filter: IUseClawMachineCoins): Promise<CoinsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminClawMachineCoinsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching claw machine coins:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createClawCoins = async (data: any): Promise<any> => {
    try {
      setLoading(true)
      const endpoint = AdminClawMachineCoinsEndpoints.create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error creating claw machine coins:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const bulkCreateClawCoins = async (data: FormData): Promise<any> => {
    try {
      setLoading(true)
      const endpoint = AdminClawMachineCoinsEndpoints.bulk_create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error bulk creating claw machine coins:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getClawCoins,
    createClawCoins,
    bulkCreateClawCoins
  }
}

export default useClawMachineCoins;